/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type DeleteLabeledItemMutationInput = {
    readonly id: string;
    readonly clientMutationId?: string | null;
};
export type DeleteLabeledItemMutationVariables = {
    input: DeleteLabeledItemMutationInput;
};
export type DeleteLabeledItemMutationResponse = {
    readonly deleteLabeledItem: {
        readonly frame: {
            readonly id: string;
            readonly labeledItems: ReadonlyArray<{
                readonly id: string;
            }>;
        };
    } | null;
};
export type DeleteLabeledItemMutation = {
    readonly response: DeleteLabeledItemMutationResponse;
    readonly variables: DeleteLabeledItemMutationVariables;
};



/*
mutation DeleteLabeledItemMutation(
  $input: DeleteLabeledItemMutationInput!
) {
  deleteLabeledItem(input: $input) {
    frame {
      id
      labeledItems {
        id
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeleteLabeledItemMutationInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteLabeledItem",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteLabeledItemMutationPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "frame",
        "storageKey": null,
        "args": null,
        "concreteType": "Frame",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "labeledItems",
            "storageKey": null,
            "args": null,
            "concreteType": "LabeledItem",
            "plural": true,
            "selections": [
              (v1/*: any*/)
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteLabeledItemMutation",
    "type": "RootMutations",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteLabeledItemMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteLabeledItemMutation",
    "id": null,
    "text": "mutation DeleteLabeledItemMutation(\n  $input: DeleteLabeledItemMutationInput!\n) {\n  deleteLabeledItem(input: $input) {\n    frame {\n      id\n      labeledItems {\n        id\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = 'd0a260f0ad04f7a2a1f57bb3164539b9';
export default node;
